import React, { useEffect, useState, useMemo } from "react"
import API from "../../Common/API"
import InlineTextField from "../../Components/InLineTextField";
import DatatableLoader from "../../Components/Loaders/DataTableLoader"
import { datatableTheme } from "../../Common/dataTableTheme"
import DataTable, { createTheme } from "react-data-table-component"
import { motion } from 'framer-motion'
import { useHistory } from "react-router-dom";
import { FaEye, FaPlus } from "react-icons/fa6";
import { FaCheckCircle, FaImages, FaPen, FaTrash } from "react-icons/fa";
import Dialog from '../../Components/Dialog'
import Button from "../../Components/Button";
import { useDispatch } from "react-redux";
import { setAlert } from "../../Store/Theme/actions";

createTheme('defaultLight', datatableTheme.default)
createTheme('defaultDark', datatableTheme.dark)
const status = [{ id: 0, value: 'Pending' }, { id: 1, value: 'Approved' }, { id: 2, value: 'Declined' }, { id: 3, value: 'In-active' }, { id: 4, value: 'Happy customer' }, { id: 5, value: 'Blocked' }]
const Enquiries = () => {

    const [loading, setLoading] = useState(true)
    const [filter, setFilter] = useState('')
    const [userList, setUserList] = useState([])
    const history = useHistory()
    const [userId, setUserId] = useState()
    const [openEditModal, setOpenEditModal] = useState(false)
    const [openDeleteModal, setOpenDeleteModal] = useState(false)
    const [openActiveModal, setOpenActiveModal] = useState(false)
    const dispatch = useDispatch()
    const [count, setCount] = useState(0)

    useEffect(() => {
        setLoading(true)
        API.get('/common/getEnquiries').then((userRes) => {
            if (userRes.status === 200) {
                setUserList(userRes.data.data)
                setLoading(false)
            }
        })
    }, [count])
    const columns = useMemo(() => [
        { name: 'S.No', selector: (row, i) => i + 1, initialActive: true, sortable: true, width: '100px' },
        { name: 'Name', selector: row => row.name, sortable: true },
        { name: 'Email', selector: row => row.email, sortable: true },
        { name: 'Mobile', selector: row => row.mobile, sortable: true },
        { name: "Message", selector: row => row.message, sortable: true }
    ], [])

    const filteredcasedetails = useMemo(() => {
        const filterSplit = filter.toLowerCase().split(' ')
        return userList.filter(c =>
            filterSplit.every(i =>
                Object.keys(c).some(j => c[j]?.toString().toLowerCase().includes(i))
            )
        )
    }, [userList, filter])

    const SubHeader = useMemo(() => (
        <div className="flex flex-row items-center">
            <InlineTextField label={"Search"} value={filter} setValue={setFilter} />
            <motion.div className="h-9 mx-2 w-9 rounded-full bg-white flex flex-col items-center cursor-pointer justify-center" onClick={() => history.push(`/createUser`)}><FaPlus /></motion.div>
        </div>
    ), [filter])// eslint-disable-line

    const editUser = (values) => {
        // setUserId(values)
        // setOpenEditModal(true)
        history.push(`/edit/${values._id}`)
    }

    const viewUser = (values) => {
        // setUserId(values)
        // setOpenEditModal(true)
        history.push(`/view/${values._id}`)
    }
    const deactivateUser = (values) => {
        setUserId(values._id)
        setOpenDeleteModal(true)
    }

    const activateUser = (values) => {
        setUserId(values._id)
        setOpenActiveModal(true)
    }

    const deleteUser = () => {
        try {
            API.post(`/users/deactivateUser/${userId}`).then((deRes) => {
                if (deRes.status === 200) {
                    dispatch(setAlert({ title: 'Error', subtitle: 'User Deactivated Successfully', active: true, type: 'error' }))
                    setOpenDeleteModal(false)
                    setCount(count + 1)
                }
            })
        } catch (err) {
            dispatch(setAlert({ title: 'Error', subtitle: 'Something went wrong', active: true, type: 'error' }))
        }
    }

    const reactiveUser = () => {
        try {
            API.post(`/users/activateUser/${userId}`).then((deRes) => {
                if (deRes.status === 200) {
                    dispatch(setAlert({ title: 'Error', subtitle: 'User activated Successfully', active: true, type: 'error' }))
                    setOpenActiveModal(false)
                    setCount(count + 1)
                }
            })
        } catch (err) {
            dispatch(setAlert({ title: 'Error', subtitle: 'Something went wrong', active: true, type: 'error' }))
        }
    }
    return (
        <motion.div>
            {loading ? (
                <DatatableLoader />
            ) : (
                <motion.div className="h-full w-full bg-opacity-10 drop-shadow-lg">
                    <DataTable
                        title="Enquiries"
                        theme="defaultLight"
                        columns={columns}
                        data={filteredcasedetails}
                        pagination
                        highlightOnHover
                        selectableRowsHighlight
                        persistTableHead
                        subHeader
                        subHeaderComponent={SubHeader}
                        noDataComponent={'There are no records to display'}
                    />
                </motion.div>
            )}
            {/* <Dialog injectClass={'min-w-screen'} showDialog={openEditModal} title={'Edit User'} onClose={() => setOpenEditModal(false)}>
                <PreviewUser registerValues={userId} onClose={() => setOpenEditModal(false)} />
            </Dialog> */}
            <Dialog injectClass="w-350px" showDialog={openDeleteModal} title={'Deactivate User'} onClose={() => setOpenDeleteModal(false)}>
                <motion.div className="w-full flex flex-col">
                    Are you sure you want to deactivate this user.
                    <motion.div className="w-full flex flex-row justify-between">
                        <Button injectClass={'bg-[red]/90 text-white rounded-full cursor-pointer'} onClick={() => setOpenDeleteModal(false)}>No</Button>
                        <Button injectClass={'bg-[green] text-white rounded-full cursor-pointer'} onClick={() => deleteUser()}>Yes</Button>
                    </motion.div>
                </motion.div>
            </Dialog>
            <Dialog injectClass="w-350px" showDialog={openActiveModal} title={'Activate User'} onClose={() => setOpenActiveModal(false)}>
                <motion.div className="w-full flex flex-col">
                    Are you sure you want to activate this user.
                    <motion.div className="w-full flex flex-row justify-between">
                        <Button injectClass={'bg-[red]/90 text-white rounded-full cursor-pointer'} onClick={() => setOpenActiveModal(false)}>No</Button>
                        <Button injectClass={'bg-[green] text-white rounded-full cursor-pointer'} onClick={() => reactiveUser()}>Yes</Button>
                    </motion.div>
                </motion.div>
            </Dialog>
        </motion.div>
    )
}

export default Enquiries